import { Component, OnInit, ElementRef, ViewChild, Injectable} from '@angular/core';
import { NgbDateStruct, NgbCalendar, NgbDatepicker, NgbDate, NgbDatepickerConfig, NgbDateParserFormatter, NgbModule,NgbAlertModule,NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import {NgbModal, ModalDismissReasons} from '@ng-bootstrap/ng-bootstrap';
import { FormsModule } from '@angular/forms';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { ApiService } from '../services/api.service';
import { CommonEventService } from '../services/common-event.service';
import '@angular/localize/init';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
  format(date: NgbDateStruct | null): string {
    return date ? `${this.pad(date.month)}/${this.pad(date.day)}/${date.year}` : '';
  }
  pad(n: number) {
    return n < 10 ? `0${n}` : `${n}`;
  }
  parse(value: string): NgbDateStruct | null {
    if (value) {
      const dateParts = value.trim().split('/');
      if (dateParts.length === 3) {
        return { month: +dateParts[0], day: +dateParts[1], year: +dateParts[2] };
      }
    }
    return null;
   
  }
  
}
@Component({
  selector: 'app-admin-dashboard',
  templateUrl: './admin-dashboard.component.html',
  styleUrls: ['./admin-dashboard.component.css'],
  providers: [
    {provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter},
  ]
})

export class AdminDashboardComponent {
  adminSearchData:any={};
  selectFilterOption:any;
  model: NgbDateStruct | undefined ;
  closeResult: string = '';
  issuesList: any = '';
  extractedList:any='';
  defaultList:any='';
  updatedList:any='';
  dashBoardArray:any=[];
  emailIdToSearch:any='';
  orderPlacedToSearch:any = '';
  quotePlacedToSearch:any = '';
  productTypeToSearch:any='';
  toDateToSearch:any ='';
  fromDateToSearch:any='';
  searchField : boolean = true;
  paginatedItems: any = [];
  itemsPerPage = 15;
  currentPage = 1;
  totalPages = 0;
  maxVisiblePages= 10;
  today:any;
  maxDate:any;

  constructor(
    public ngb : NgbModule,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public apiService : ApiService,
    public ngbDatepickerModule : NgbDatepickerModule,
    public ngbAlertModule : NgbAlertModule,
    public formsModule : FormsModule,
    public commonService : CommonEventService
  ){
  }

  ngOnInit(): void {
    // this.adminSearchData.searchByOptionVal = "0";
    this.callTogetAdminDashboardDatas('','','',1);
    this.today = new Date();
    this.maxDate = { 
      year: this.today.getFullYear(), 
      month: this.today.getMonth() + 1, 
      day: this.today.getDate() 
    };
    //this.clearSearchData();
  }
  ngAfterViewInit(): void {
    this.setupPagination();
  }
  
  selectByFilter(event:any){
    this.selectFilterOption = this.adminSearchData.searchByOptionVal == "date" ? "date" : this.adminSearchData.searchByOptionVal == "email" ? "emailId" : this.adminSearchData.searchByOptionVal == "productType" ? "productType" : '';
    //On change of filter option clear the old search data
    this.emailIdToSearch = '';
    this.productTypeToSearch = '';
    this.fromDateToSearch = '';
    this.toDateToSearch = '';
  }
  alertCall(title:any,message:any){
    Swal.fire({
      toast: false,
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: true,
       allowOutsideClick: false,
      title:title,
      html:message,
      confirmButtonText: 'Ok'
    }).then((result) => {
      this.clearSearchData();
    });
  }
  searchForData(selectedPageNum:any){
    if(this.selectFilterOption == 'emailId'){
      if(this.emailIdToSearch == ''){
        this.commonService.showtoast('Please enter Email Id.','warning');
      }else{
        this.callTogetAdminDashboardDatas('email',this.emailIdToSearch,'',selectedPageNum);
      }
    }else if(this.selectFilterOption == 'productType'){
      if(this.productTypeToSearch == ''){
        this.commonService.showtoast('Please enter the data.','warning');
      }else{
        this.callTogetAdminDashboardDatas('product',this.productTypeToSearch,'',selectedPageNum);
      }
    }else if(this.selectFilterOption == 'date'){
      var fromDate = '';
      var toDate = '';
      if (this.fromDateToSearch) {
        // Format the date as mm/dd/yyyy
        const day = this.fromDateToSearch.day < 10 ? '0' + this.fromDateToSearch.day : this.fromDateToSearch.day;
        const month = this.fromDateToSearch.month < 10 ? '0' + this.fromDateToSearch.month : this.fromDateToSearch.month;
        fromDate = `${month}/${day}/${this.fromDateToSearch.year}`;
      }
      if(this.toDateToSearch){
        const day = this.toDateToSearch.day < 10 ? '0' + this.toDateToSearch.day : this.toDateToSearch.day;
        const month = this.toDateToSearch.month < 10 ? '0' + this.toDateToSearch.month : this.toDateToSearch.month;
        toDate = `${month}/${day}/${this.toDateToSearch.year}`;
      }
      if(this.fromDateToSearch == ''){
        this.commonService.showtoast('Please enter the from date.','warning');
      }else{
        this.callTogetAdminDashboardDatas('date',fromDate,toDate,selectedPageNum);
      }
    }
  }
  clearSearchData(){
    this.selectFilterOption = '';
    this.adminSearchData.searchByOptionVal = '0';
    this.quotePlacedToSearch = '';
    this.orderPlacedToSearch = '';
    this.emailIdToSearch = '';
    this.productTypeToSearch = '';
    this.callTogetAdminDashboardDatas('','','',1);
  }
  openListOfSpecification(content:any,extractedData:any,defaultData:any,updatedData:any){
    this.extractedList = extractedData;
    this.defaultList = defaultData;
    this.updatedList = updatedData;
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  callTogetAdminDashboardDatas(opt1:any,opt2:any,opt3:any,page:any){
    this.commonService.loadingShow();
    this.paginatedItems=''
    this.commonService.commonMainObj.dashboardData = {};
    this.dashBoardArray=[];
    this.apiService.getDashboardData(opt1,opt2,opt3,page).subscribe((data: any)=>{
      if(data.data == null || data.data == ''){
        this.paginatedItems=''
        this.dashBoardArray=[];
        this.alertCall('Alert!!',"No data found matching the filtered criteria");
      }else{
        this.commonService.commonMainObj.dashboardData = data.data;
        this.currentPage = parseInt(data.page)+1;
        let count = ((this.currentPage -1)*15)+1;
        for(let itemIndx in this.commonService.commonMainObj.dashboardData){
          //let count =  parseInt(itemIndx) + 1;
          let childCount:any = 0;
          this.commonService.commonMainObj.dashboardData[itemIndx].parentActivity.index=count;
          this.dashBoardArray.push(this.commonService.commonMainObj.dashboardData[itemIndx].parentActivity);
          if(this.commonService.commonMainObj.dashboardData[itemIndx].childActivities.length != 0){
            for(let childItemIndx in this.commonService.commonMainObj.dashboardData[itemIndx].childActivities){
              if(this.commonService.commonMainObj.dashboardData[itemIndx].parentActivity.activityId == this.commonService.commonMainObj.dashboardData[itemIndx].childActivities[childItemIndx].parentActivityId){
                let cn =  parseInt(childItemIndx) + 1;
                childCount = cn;
                this.commonService.commonMainObj.dashboardData[itemIndx].childActivities[childItemIndx].index=this.commonService.commonMainObj.dashboardData[itemIndx].parentActivity.index+'.'+cn;
                this.dashBoardArray.push(this.commonService.commonMainObj.dashboardData[itemIndx].childActivities[childItemIndx]);
              }
            }
          }
          count = count+1;
        }
        console.log("this.dashBoardArray",this.dashBoardArray);
        setTimeout(() => {
          this.totalPages = Math.ceil(data.totalElements / this.itemsPerPage);
          this.updatePagination(this.totalPages);
          this.commonService.loadingHide();
        }, 500);
      }
    },error =>{
      console.log('Error in getting dashboard data', error);   
    })
  }
  openUploadedFileIssues(content:any,issueDatas:any){
    this.issuesList = issueDatas;
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"});
   
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }
  
  updatePagination(totalPages:any){
    this.totalPages = totalPages;
    this.paginateTable();
    setTimeout(() => this.setupPagination(), 0); 
  }

  paginateTable(){
    var startIndex = ((this.currentPage -1)*15)+1;
    //this.paginatedItems = this.dashBoardArray.slice(startIndex, startIndex + this.itemsPerPage);
    this.paginatedItems = this.dashBoardArray;
  }

  setupPagination(){
    $('#pagination').empty();
    var startPage;
    var endPage;

    if (this.totalPages <= this.maxVisiblePages) {
      startPage = 1;
      endPage = this.totalPages;
    }else {
      if (this.currentPage <= 5) {
        startPage = 1;
        endPage = 10;
      } else if (this.currentPage >= this.totalPages - 4) {
        startPage = this.totalPages - 9;
        endPage = this.totalPages;
      } else {
        startPage = this.currentPage - 4;
        endPage = this.currentPage + 5;
      }
    }
    if (this.currentPage > 1) {
      $('#pagination').append(`<a href="#" class="page-link prev" data-page="${this.currentPage - 1}">Previous</a>`);
    }
    for (let i = startPage; i <= endPage; i++) {
      $('#pagination').append(
        `<a href="#" class="page-link ${i === this.currentPage ? 'active' : ''}" data-page="${i}">${i}</a>`
      );
    }
    if (this.currentPage < this.totalPages) {
      $('#pagination').append(`<a href="#" class="page-link next" data-page="${this.currentPage + 1}" (click)="nextPage($event)">Next</a>`);
    } 
    $('.page-link').on('click', (event) => {
      event.preventDefault();
      this.currentPage = parseInt($(event.currentTarget).attr('data-page')!, 10);
      if(this.selectFilterOption == 'emailId' || this.selectFilterOption == 'productType' || this.selectFilterOption == 'date'){
        this.searchForData(this.currentPage);
      }else{
        this.callTogetAdminDashboardDatas('','','',this.currentPage);
      }
      
      setTimeout(() => {
        this.paginateTable();
        this.setupPagination();
      }, 3000);
    });
  }

  downloadBomFile(){
    var downLoadUrl = this.apiService.scaBOMFileDownloadUrl+this.commonService.commonMainObj.finalBomDataToPurchase.bomId
    downLoadUrl = this.commonService.commonMainObj.userId?downLoadUrl+ '&userId=' +this.commonService.commonMainObj.userId:downLoadUrl+ '&emailId=' +this.commonService.commonMainObj.defaultEmail;
    window.open(downLoadUrl,'_self');
  }

  productTypeClick(event:any){

  }
  downloadUploadedFile(activityId:any){
    var downloadUrl= this.apiService.autoBOMFileDownloadUrl+activityId+".zip";
    this.apiService.downloadZipFile(activityId).subscribe((data: any)=>{
      if(data){
       window.open(downloadUrl,'_self');
      }
      },error =>{  
       if(error.status == 404){
        this.commonService.alertCall("Alert!", 'File Not Found');
      }
    })
  }
  downloadUploadedBomFile(bomFileId:any){
    var downloadUrl= this.apiService.autoBOMFileDownloadUrl+bomFileId+'&isBom=True';
    this.apiService.downloadBomFile(bomFileId).subscribe((data: any)=>{
      if(data){
       window.open(downloadUrl,'_self');
      }
      },error =>{  
       if(error.status == 404){
        this.commonService.alertCall("Alert!", 'File Not Found');
      }
    })
  }
}
